var _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.25C8.22391 0.25 9.87721 0.934819 11.0962 2.15381C12.3152 3.37279 13 5.02609 13 6.75C13 8.36 12.41 9.84 11.44 10.98L11.71 11.25H12.5L17.5 16.25L16 17.75L11 12.75V11.96L10.73 11.69C9.59 12.66 8.11 13.25 6.5 13.25C4.77609 13.25 3.12279 12.5652 1.90381 11.3462C0.684819 10.1272 0 8.47391 0 6.75C0 5.02609 0.684819 3.37279 1.90381 2.15381C3.12279 0.934819 4.77609 0.25 6.5 0.25ZM6.5 2.25C4 2.25 2 4.25 2 6.75C2 9.25 4 11.25 6.5 11.25C9 11.25 11 9.25 11 6.75C11 4.25 9 2.25 6.5 2.25Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.bb61c459eebfe68b1a9c91dc72c3c9f8.svg";
export { ForwardRef as ReactComponent };